export enum Tool {
  Email = 'email',
  Sms = 'sms',
}
